<template>
  <div
    class="muiltple-choice-content"
    :class="{
      'has-image-choice': $store.state.slide.type == 'imageChoice',
      'has-padding': isShowFooter && !presentation.isReactionEnabled,
      'hide-audience-result': !slide.showVotingResultsOnAudience
    }"
  >
    <div>
      <div
        class="slide-img-wrapper"
        v-if="$store.state.slide.image && $store.state.slide.type != 'pickAnswer'"
      >
        <Loading v-if="isLoading" />
        <img
          :src="$store.state.slide.image.large"
          alt
          class="slide-img"
          ref="slide-imgg"
          @load="_imgLoaded"
          v-else
        >
      </div>
      <div
        class="mb-2 sub-header"
        v-if="checkNoneCorrectAnswer"
      >
        {{ $t('noneOptionsCorrect') }}
      </div>
      <div
        class="sub-header"
        v-if="$store.state.slide.type == 'imageChoice' && $store.state.slide.SlideOptions.length"
      >
        {{ $t("clickToSeeFullSize") }}
      </div>

      <div>
        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && $store.state.slide.type != 'pickAnswer'"
        >
          {{ $t("multipleChoiceInstruction") }} {{ $store.state.slide.limitChoice }} {{ $t("options") }}.
        </div>

        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && !this.$store.state.slide.isCorrectGetPoint && $store.state.slide.type == 'pickAnswer'"
        >
          {{ $t("quizYouMustPickAll") }}
        </div>
        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && this.$store.state.slide.isCorrectGetPoint && $store.state.slide.type == 'pickAnswer'"
        >
          {{ $t("mustNotPickIncorrectAnswer") }}
        </div>

        <div
          class="sub-header"
          v-if="!$store.state.slide.multipleChoice && $store.state.slide.type == 'pickAnswer' && checkAnyCorrectAnswer() > 1"
        >
          {{ $t("youCanPickAnyCorrectAnswer") }}
        </div>

        <div
          class="progress-bar-time-limit"
          :class="{'mb-0': !$store.state.presentation.presenting || $store.state.presentation.presenting && !$store.state.slide.hasTimeLimit }"
          v-if="hasTimeLimitOption"
        >
          <ProgressBarTimer />
        </div>
        <div class="padding">
          <template v-if="slide.type === 'multipleChoice'">
            <Option
              :id="slideOption.id"
              v-for="slideOption in slideOptions"
              :base-colour="slide.baseColour"
              :text-colour="slide.textColour"
              variant="text"
              :key="slideOption.id"
              :title="slideOption.title"
              :image="slideOption.imageCropped"
              :multiple-select="slide.multipleChoice"
              v-model="submittedAnswer"
              :number-of-same-answer="slideOption.votesCount"
              :number-of-answers="numberOfAnswers"
              :show-number-of-same-answer="showNumberAnswer"
              :show-result="showCorrectOption"
              :correct="slideOption.correct"
              :disabled="slideOption.disabled || isSubmittedForm"
              :is-can-select-option="true"
              :is-submitted="isSubmittedForm"
              :stop-submission="slide.stopSubmission"
              :show-percent="slide.showPercentage"
              :is-option-user-count-overlay-visible="isOptionUserCountOverlayVisible"
            />
          </template>

          <template v-if="slide.type === 'imageChoice'">
            <Masonry masonry-id="image-choice-slide-option-masonry">
              <MasonryItem :key="slideOption.id" v-for="slideOption in slideOptions">
                <Option
                  :id="slideOption.id"
                  :base-colour="slide.baseColour"
                  :text-colour="slide.textColour"
                  variant="image"
                  :title="slideOption.title"
                  @handle-image-load="redrawMasonryById('image-choice-slide-option-masonry')"
                  :image="slideOption.imageCropped"
                  :multiple-select="slide.multipleChoice"
                  v-model="submittedAnswer"
                  :number-of-same-answer="slideOption.votesCount"
                  :number-of-answers="numberOfAnswers"
                  :show-number-of-same-answer="showNumberAnswer"
                  :show-result="showCorrectOption"
                  :correct="slideOption.correct"
                  :disabled="slideOption.disabled || isSubmittedForm"
                  :is-can-select-option="true"
                  :is-submitted="isSubmittedForm"
                  :zoom-full-size-image="true"
                  :stop-submission="slide.stopSubmission"
                  :show-percent="slide.showPercentage"
                  :is-option-user-count-overlay-visible="isOptionUserCountOverlayVisible"
                />
              </MasonryItem>
            </Masonry>
          </template>
        </div>
        <div
          class="count-choice"
          v-if="$store.state.slide.multipleChoice &&
            $store.state.slide.limitChoice != $store.state.slide.SlideOptions.length &&
            getVoteLeft && $store.state.slide.SlideOptions.length > 2"
        >
          {{ getVoteLeft }} {{ $t("choicesLeft") }}
        </div>
      </div>

      <!-- MultipleChoice && Image choice submit button -->
      <div
        class="sticky quiz-footer animate__animated animate__fadeIn animate__faster"
        :style="{'background-color': slide.baseColour}"
        :class="{'show': isShowFooter}"
      >
        <div class="quiz-footer--content">
          <QuizFormSubmitButton
            @submit="submit"
            :disabled="slide.multipleChoiceStatus == 2 || disableSubmit || isStopSubmission"
            :is-form-submitted="isSubmittedForm"
            :is-waiting-call-api="true"
            :is-multiple-choice="true"
          />
        </div>
        <p
          class="pt-0 mt-0 text-center padding text-footer"
          v-if="isSubmittedForm && !checkLastSlide"
        >
          {{ $t('alreadyAnswer') }}
          <span v-if="!presentation.audiencePacing && !slide.stopSubmission">
            {{ $t('waitingScreen') }}
          </span>
        </p>
        <div class="pt-0 text-center text-danger padding text-footer" v-if="error">
          {{ error }}
        </div>
        <div
          class="pt-0 mt-0 text-center padding text-footer"
          v-if="slide.stopSubmission"
        >
          {{ $t("stopSubmission") }}
        </div>
        <QuizNextSlide
          v-if="presentation.audiencePacing || (isSubmittedForm && checkLastSlide)"
          class="animation-text next-slide-btn"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Config from '@/config'
import Util from '@/util'
import EvenBus from '@/eventBus'
import Loading from '@/components/Loading'
import storage from '@/services/storage'
import ProgressBarTimer from '@/components/ProgressBarTimer'
import QuizFormSubmitButton from '@/components/quiz/QuizFormSubmitButton.vue'
import Option from '@/components/quiz/Option.vue'
import SlideOptionApi from '@/api/slide-option'
import QuizNextSlide from '@/components/quiz/QuizNextSlide.vue'

// components
import Masonry, { masonryMixin } from '@/components/masonry/Masonry.vue'
import MasonryItem from '@/components/masonry/MasonryItem.vue'

export default {
  components: {
    Loading,
    ProgressBarTimer,
    QuizFormSubmitButton,
    Option,
    Masonry,
    MasonryItem,
    QuizNextSlide,
  },
  mixins: [masonryMixin],
  props: {
    answeredSlideIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      submiting: false,
      error: '',
      count: 0,
      radioSelected: 0,
      isLoading: false,
      limitText: 150, // limit input type answer submit
      typeAnswerValue: '',
      boxImgChoiceBg: '',
      isShowFooter: false,
      submittedAnswer: null,
      isSubmittedForm: false,
      disableSubmit: true,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
      slide: (state) => state.slide,
      slideOptions: (state) => state.slide.SlideOptions,
      numberOfAnswers: (state) => {
        return state.slide.SlideOptions
          .filter((item) => item.votesCount)
          .reduce((accumulator, item) => accumulator + item.votesCount, 0)
      },
    }),
    hasTimeLimitOption() {
      return this.$store.state.slide.type === 'imageChoice' ||
       this.$store.state.slide.type === 'multipleChoice' ||
       this.$store.state.slide.type === 'openEnded' ||
       this.$store.state.slide.type === 'wordCloud'
    },
    getVoteLeft() {
      if (!this.slide.multipleChoice) return 0
      let countVoted = 0
      if (this.submittedAnswer && this.submittedAnswer.length) {
        countVoted = this.submittedAnswer.length
      }
      const count = this.$store.state.slide.limitChoice - countVoted
      if (this.slide.multipleChoice) {
        let SlideOptions = this.slideOptions
        if (count) {
          SlideOptions = this.slideOptions.map((item) => {
            item.disabled = false
            return item
          })
        } else {
          SlideOptions = this.slideOptions.map((item) => {
            if (!this.submittedAnswer.includes(item.id)) {
              item.disabled = true
            }
            return item
          })
        }
        this.$store.dispatch('updateSlide', {
          SlideOptions,
        })
      }
      return count
    },
    isShowingNonStickySubmitButton() {
      const slideTypes = ['multipleChoice', 'imageChoice']
      return !slideTypes.includes(this.slide.type) &&
      this.slide.SlideOptions && this.slide.SlideOptions.length
    },
    showNumberAnswer() {
      if (!this.slide.showVotingResultsOnAudience) return false
      if (this.slide.hideResult) return false
      return true
    },
    showCorrectOption() {
      if (!this.slide.showVotingResultsOnAudience) return false
      if (!this.slide.showCorrectOption) return false
      return true
    },
    checkLastSlide() {
      const index = this.$store.state.slides.findIndex((item) => {
        return item.id === this.$store.state.slide.id
      })

      if (index !== -1 && index === this.$store.state.slides.length - 1) {
        return true
      }

      return false
    },
    checkNoneCorrectAnswer() {
      if (!this.isSubmittedForm || !this.slide.showCorrectOption) return false
      const correctOptions = this.slide.SlideOptions.filter((item) => {
        return item.correct
      })
      if (!correctOptions.length) return true
      return false
    },
    isStopSubmission() {
      if (!this.slide.stopSubmission) return false
      return true
    },
    isOptionUserCountOverlayVisible() {
      return this.slide.type === 'imageChoice' && !this.slide.showCorrectOption
    },
  },
  watch: {
    '$store.state.slide': function () {
      setTimeout(() => {
        if (this.$refs['slide-imgg'] && !this.$refs['slide-imgg'].complete) {
          this.isLoading = true
        }
      }, 1)
    },
    submittedAnswer() {
      this.checkNoSelectedAnswer()
    },
    '$store.state.slide.multipleChoice': function () {
      if (this.isSubmittedForm) return
      if (this.slide.multipleChoice) {
        this.submittedAnswer = []
      } else {
        this.submittedAnswer = null
      }
    },
  },

  mounted() {
    this.getSlideOptions()
    if (this.answeredSlideIds.length) {
      this.submittedAnswer = this.answeredSlideIds
      this.isSubmittedForm = true
    }
    if (this.submittedAnswer === null && this.slide.multipleChoice) {
      this.submittedAnswer = []
    }
    this.checkNoSelectedAnswer()
    setTimeout(() => {
      this.isShowFooter = true
    }, 300)
  },

  destroyed() {
    if (window.onscroll) {
      window.onscroll = null
    }
  },
  methods: {
    endPresentation() {
      this.$store.state.slide.isEndSlide = true
      this.$store.dispatch('updateSlide', {
        isEndSlide: true,
      })
    },
    async getSlideOptions() {
      const slideId = this.slide.id
      const resp = await SlideOptionApi.getSlideOptions({
        type: this.slide.type,
        slideId,
        uniqueAccessCode: this.presentation.uniqueAccessCode,
      })
      const options = resp.rows.map((item) => {
        if (!item.votesCount) item.votesCount = 0
        return item
      })
      this.updateVotesCount(options, slideId)
    },

    updateVotesCount(options, slideId) {
      const { SlideOptions } = this.slide

      if (!SlideOptions || slideId !== this.slide.id) return

      SlideOptions.forEach((item) => {
        if (!item.votesCount) item.votesCount = 0

        if (!options) return

        const matchOption = options.find((option) => option.id === item.id)

        if (matchOption) {
          item.votesCount = matchOption.votesCount
        }
      })

      this.$store.dispatch('updateSlide', {
        SlideOptions,
      })
    },

    checkNoSelectedAnswer() {
      let isSelectedAnswer = false
      if (this.slide.multipleChoice && (!this.submittedAnswer || !this.submittedAnswer.length)) {
        isSelectedAnswer = true
      }
      if (!this.slide.multipleChoice && !this.submittedAnswer) {
        isSelectedAnswer = true
      }
      this.disableSubmit = isSelectedAnswer
    },
    checkAnyCorrectAnswer() {
      let count = 0
      if (!this.$store.state.slide.SlideOptions) return count
      this.$store.state.slide.SlideOptions.forEach((item) => {
        if (item.correct) {
          count++
        }
      })
      return count
    },

    async submit() {
      if (this.submiting) return

      if (this.slide.stopSubmission) return

      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      let vote = []
      if (this.slide.multipleChoice) {
        vote = this.submittedAnswer
      } else {
        vote = [this.submittedAnswer]
      }
      if (!vote.length) {
        return
      }

      this.error = ''
      const payload = {
        presentation: this.$store.state.presentation.id,
        slide: this.$store.state.slide.id,
        audience: this.audienceId,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        slideTimestamp: this.$store.state.slide.slideTimestamp,
        config: {
          timeToAnswer: this.$store.state.slide.timeToAnswer,
          quizTimestamp: this.$store.state.slide.quizTimestamp,
          multipleChoice: this.$store.state.slide.multipleChoice,
          isCorrectGetPoint: this.$store.state.slide.isCorrectGetPoint,
          stopSubmission: this.$store.state.slide.stopSubmission,
          fastAnswerGetMorePoint: this.$store.state.slide
            .fastAnswerGetMorePoint,
          otherCorrectQuiz: this.$store.state.slide.otherCorrectQuiz,
          correctQuizTypeAnswer: this.$store.state.slide.correctQuizTypeAnswer,
          maxPoint: this.$store.state.slide.maxPoint,
          minPoint: this.$store.state.slide.minPoint,
          quizToken: this.$store.state.slide.quizToken,
          SlideOptions: this.$store.state.slide.SlideOptions.map((dataOption) => {
            return {
              id: dataOption.id,
              correct: dataOption.correct,
            }
          }),
        },
        type: this.$store.state.slide.type,
        slideType: this.$store.state.slide.slideType,
      }

      payload.vote = vote

      this.submiting = true

      this.$http.post(Config.api.createAnswer, payload).then(
        () => {
          this.submiting = false
          this.isSubmittedForm = true
          const presentationId = this.$store.state.presentation.id
          const answeredSlides = storage.getValueByPresentation(presentationId, 'answeredSlides', {})
          if (!answeredSlides[this.$store.state.slide.id]) {
            answeredSlides[this.$store.state.slide.id] = {
              vote,
            }
          } else {
            answeredSlides[this.$store.state.slide.id].vote = vote
          }
          storage.setValueByPresentation(presentationId, 'answeredSlides', answeredSlides)
          if (
            this.$store.state.slide.type == 'multipleChoice' ||
            this.$store.state.slide.type == 'imageChoice'
          ) {
            EvenBus.$emit('multiple-choice-voted')
          }

          if (this.$store.state.presentation.audiencePacing) {
            if (!this.slide.showVotingResultsOnAudience) {
              EvenBus.$emit('skipSlide')
            }
          } else {
            EvenBus.$emit('confirmNextSlide')
          }

          if (this.$store.state.slide.type === 'multipleChoice') {
            Util.gaTrackEvent(
              'Audience > Multiple Choice',
              'Submit answer',
              'Audience Submit Answer',
            )
          } else if (this.$store.state.slide.type === 'imageChoice') {
            Util.gaTrackEvent(
              'Audience > Image Choice',
              'Submit answer',
              'Audience Submit Answer',
            )
          }
        },
        (err) => {
          this.submiting = false
          if (err.body && err.errorCode === 411) {
            this.error = this.$t('submissionClosedButton')
          } else {
            this.error = this.$t('openendedSubmissionFail')
          }
          Util.gaTrackEvent(
            'Multiple Choice Submit',
            'Audience submit fail',
            JSON.stringify(err),
          )
        },
      )
    },

    _imgLoaded() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.has-image-choice {
  .input-wrapper {
    overflow: hidden;
  }
}

.count-choice {
  text-align: center;
  padding: 0 16px;
  padding-bottom: 16px;
  opacity: 0.7;
}

.sub-header {
  text-align: center;
  padding: 0 16px 0 16px;
  opacity: 0.7;
}
.fancy-label--text {
  word-wrap: break-word;
}

.slide-img-wrapper {
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 0.83em;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 15px;

  .slide-img {
    margin-bottom: 16px;
  }

  & /deep/ {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}

.quiz-footer {
  display: none;
  width: 100%;
  z-index: 100;
  &.show {
    display: block;
  }
  &.sticky {
    transition: all 0.3s ease;
    box-shadow: 0px -4px 12px rgba(0, 0, 0, 0.04);
    position: fixed;
    bottom: 0;
    left: 0;
    .quiz-footer--content {
      padding: 16px;
    }
  }
  &.type-answer__footer {
    margin-top: 32px;
  }
}

.quiz-footer--content {
  max-width: 710px;
  width: 100%;
  margin: 0 auto;
}

.has-padding {
  padding-bottom: 120px;
}

.padding {
  padding: 16px;
}

.text-footer {
  font-size: 14px;
  line-height: 18px;
}
.next-slide-btn {
  padding-top: 0;
  margin-bottom: 8px;
}

.hide-audience-result {
  & /deep/ {
    .aha-option--text {
      .aha-option__user-count {
        display: none;
      }
      .aha-option__label {
        margin-right: 0;
      }
    }
  }
}
</style>
